import { addActionBarItem } from '@vendure/admin-ui/core';
import { registerReactCustomDetailComponent } from '@vendure/admin-ui/react';
import { ChannelSelector } from './components/ChannelSelector';

export default [
    addActionBarItem({
        id: 'test-button',
        label: 'Test Button',
        locationId: 'customer-detail',
    }),
    registerReactCustomDetailComponent({
        locationId: 'customer-detail',
        component: ChannelSelector,
    }),
];
